export default {
    methods: {
        $_snipText(value, snippetLength = 30) {
            const requiresSnipping = value.length > snippetLength;

            if (!requiresSnipping)
                return value;
            else 
                return `${value.substring(0, snippetLength)}...`;
        }
    }
}